<template>
  <v-container class="facture-container mx-auto">
    <oeaq-header></oeaq-header>

    <Facture
      v-if="facture"
      :facture="facture"
      :inputFields="false"
      :showAlert="true"
    >
      <template v-slot:btn-paiement>
        <v-sheet>
          <v-card flat align="center" class="pa-4">
            <v-dialog
              v-model="showMonerisCheckout"
              width="600"
              @click:outside="reinitializeComponent"
              :key="monerisDialogKey"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="#3374FF"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  x-large
                  tile
                >
                  Payer
                </v-btn>
              </template>
              <v-card height="800">
                <MonerisCheckout
                  :idFacture="idFacture"
                  @customClose="reinitializeComponent"
                  @paiementEudonetComplete="setPaiementEudonetComplete"
                ></MonerisCheckout>
              </v-card>
            </v-dialog>
          </v-card>
        </v-sheet>
      </template>
    </Facture>
    <template v-else>
      <v-card class="pa-12 mt-8">
        <p class="mb-8">Chargement de la facture...</p>
        <v-progress-circular indeterminate></v-progress-circular>
      </v-card>
    </template>

  </v-container>
</template>

<script>
import Facture from "../components/facture/Facture"
import Header from "../components/Header"
import MonerisCheckout from "../components/facture/moneris/MonerisCheckout";
import { api } from "../plugins/api";

export default {
  components: {
    Facture,
    "oeaq-header": Header,
    MonerisCheckout
  },
  data() {
    return {
      facture: null,
      showMonerisCheckout: false,
      monerisDialogKey: 0,
      factureKey: 0,
      paiementEudonetComplete: false,
      waitingOverlay: false,
    };
  },
  computed: {
    idFacture() {
      return this.$route.params.idFacture;
    },
  },
  created() {
    this.chargerLaFacture();
  },
  methods: {
    reinitializeComponent() {
      this.waitingOverlay = !this.paiementEudonetComplete;
      this.showMonerisCheckout = false;
      this.monerisDialogKey += 1;
      this.chargerLaFacture();
    },
    setPaiementEudonetComplete() {
      this.paiementEudonetComplete = true;
      if (this.showMonerisCheckout == false) {
        this.chargerLaFacture();
      }
      this.waitingOverlay = false;
    },
    async chargerLaFacture() {
      await this.getFacture(this.idFacture)
        .then(async (response) => {
          this.facture = response.data;
          if (this.facture) {
            this.useMonerisCheckout = true;
          }
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
              message: error.response.status,
            });
          } else {
            this.$router.push({
              name: "InternalError",
              message: error.response.message,
            });
          }
        });
    },
    getFacture: (factureId) => api.get("factures/" + factureId),
  }
}
</script>

<style lang="scss" >
.facture-container {
  max-width: 800px;
}
.btn {
  text-transform: uppercase;
  letter-spacing: 1px;
}
</style>